import React from "react";
import { Link, useLocation } from "react-router-dom";

function ScrollTopLink({ to, onClick, ...props }) {
  const { pathname } = useLocation();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (event.defaultPrevented) {
      return;
    }

    if (typeof to === "string" && pathname === to) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  };

  return <Link to={to} onClick={handleClick} {...props} />;
}

export default ScrollTopLink;
